import {
    AnnualTaxGroupType,
    getOverviewSectionsByType
} from "@pages/payroll/annualTaxSettlement/AnnualTaxSettlement.utils";
import {
    AnnualTaxSettlementOverviewCell,
    AnnualTaxSettlementOverviewTable
} from "@pages/payroll/annualTaxSettlement/overView/AnnualTaxSettlement.styles";
import { IOverviewBaseProps } from "@pages/payroll/payslip/overview/OverviewBase";
import { getCompanyCurrency } from "@utils/CompanyUtils";
import { memoizeOne } from "@utils/memoizeOne";
import React from "react";

import CurrencyType from "../../../../types/Currency";
import { getEntityMemoKey } from "../../../../views/formView/Form.utils";

interface IProps extends IOverviewBaseProps {
    type: AnnualTaxGroupType;
}

export default class AnnualTaxSettlementOverview extends React.Component<IProps> {
    getSections = memoizeOne(() => {
        return getOverviewSectionsByType(this.props.storage, this.props.type);
    }, () => [getEntityMemoKey(this.props.storage)]);

    render(): React.ReactElement {
        return <AnnualTaxSettlementOverviewTable>
            {this.getSections().map((row, index) => (
                <React.Fragment key={index}>
                    <AnnualTaxSettlementOverviewCell>
                        {row.number}
                    </AnnualTaxSettlementOverviewCell>
                    <AnnualTaxSettlementOverviewCell $isSubRow={row.isSubRow} $isBold={row.isBold}>
                        {row.title}
                    </AnnualTaxSettlementOverviewCell>
                    <AnnualTaxSettlementOverviewCell $isBold={row.isBold}>
                        {CurrencyType.format(row.value, { currency: getCompanyCurrency(this.props.storage.context) })}
                    </AnnualTaxSettlementOverviewCell>
                </React.Fragment>
            ))}
        </AnnualTaxSettlementOverviewTable>;
    }
}
